import { render, staticRenderFns } from "./esports.vue?vue&type=template&id=68d009cf&"
import script from "./esports.vue?vue&type=script&lang=js&"
export * from "./esports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SportIcon: require('/var/web/bet777.es/components/sport/icon.vue').default,UiCardWrapper: require('/var/web/bet777.es/themes/dark/ui/Card/Wrapper.vue').default})
